import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'power', 'Power', [["path",{"d":"M7 6a7.75 7.75 0 1 0 10 0"}],["path",{"d":"M12 4l0 8"}]]);